module.exports = __webpack_public_path__ + "static/media/btn-left.2a7917a0.svg";